import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import Link from 'next/link';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface Props {
  jobCategory: string;
  source: string;
}

interface CompanyJobListingSeoLinkagesProps {
  source: string;
}
export const CompanyJobsLinkageUrlMapping: any = {
  Product: 'product-jobs',
  'E-Commerce': 'ecommerce-jobs',
  'Fintech/EdTech': 'fintech-edtech-jobs',
};
export const getCompanyJobsLinkageUrl = (jobCategory: any) => {
  const categoryDomain = CompanyJobsLinkageUrlMapping[jobCategory];
  return `/${categoryDomain}`;
};
const CompanyListingCard: React.FC<Props> = ({jobCategory, source}) => {
  const jobsUrl = getCompanyJobsLinkageUrl(jobCategory);
  const locationUrl = `${jobsUrl}?source=${source}`;

  return (
    <Link href={locationUrl} passHref legacyBehavior>
      <a
        target="_blank"
        rel="noopener noreferrer"
        style={{textDecoration: 'none', marginRight: '50px'}}
      >
        <Card
          sx={{
            borderRadius: '8px',
            boxShadow: '0 10px 30px 0 rgba(0,0,0,.06)',
            border: '1px solid #ececec',
            backgroundColor: '#fff',
            transition: 'box-shadow 0.2s',
            '&:hover': {boxShadow: 'none'},
            padding: '20px !important',
            marginRight: '0px',
            height: {xs: 122, xl: 95},
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              padding: '0px !important',
            }}
          >
            <Box sx={{width: '300px'}}>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 300,
                  color: '#000',
                  fontFamily: 'Nunito Sans',
                  textDecoration: 'none',
                }}
              >
                {jobCategory} Companies Jobs
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: '700',
                  cursor: 'pointer',
                  color: '#e9630c',
                  fontFamily: 'Nunito Sans',
                  textDecoration: 'none ',
                }}
              >
                View all jobs
              </Typography>
            </Box>

            <IconButton
              sx={{
                opacity: 0.3,
                height: '0.8em',
                width: '0.8em',
                fontSize: '0.8em',
              }}
            >
              <ArrowForwardIcon
                sx={{
                  height: '0.7em',
                  width: '0.8em',
                }}
              />
            </IconButton>
          </CardContent>
        </Card>
      </a>
    </Link>
  );
};
export default (source: any) => {
  return (
    <>
      <Typography sx={{fontSize: 18, fontWeight: 700, mt: 1, ml: 6.5}}>
        Explore jobs based on trending domains
      </Typography>
      <Grid
        container
        spacing={3}
        justifyContent={{xs: 'space-between', md: 'space-between'}}
        ml={'28px'}
        width={'auto'}
        mt={-2}
        mb={-3}
        mr={4}
      >
        <Grid item md={4}>
          <CompanyListingCard jobCategory="Product" source={source?.source} />
        </Grid>
        <Grid item md={4}>
          <CompanyListingCard
            jobCategory="E-Commerce"
            source={source?.source}
          />
        </Grid>
        <Grid item md={4}>
          <CompanyListingCard
            jobCategory="Fintech/EdTech"
            source={source?.source}
          />
        </Grid>
      </Grid>
    </>
  );
};
